import {
  TBarcodeScannerLogColumnKey,
} from './debug-barcode-scanner.ts';

const columns: Record<TBarcodeScannerLogColumnKey, string> = {
  timestampEpochMilliseconds: 'Zeitstempel',
  eventType: 'Ereignis',
  characterLabel: 'Zeichen',
  isControlCharacter: 'Steuerzeichen',
  key: 'Taste',
  code: 'Code',
  keyCode: 'Tastencode',
  modifierList: 'Modifikatoren',
  inputType: 'Eingabetyp',
  inputValueSnapshot: 'Feldwert',
};

export default {
  description: 'Klicken Sie in das Feld unten und scannen Sie einen Barcode, um jedes Tastatur- und Eingabeereignis zu sehen, das der Browser in der Reihenfolge des Auftretens auslöst. Das neueste Ereignis wird oben im Protokoll angezeigt. Nicht druckbare Steuerzeichen werden mit ihrer Standardabkürzung angezeigt, zum Beispiel <GS> für das Group Separator-Zeichen (0x1D).',
  scanInputPlaceholder: 'Hier klicken und einen Barcode scannen',
  eventCount: '{count} Ereignisse protokolliert',
  copyLogButtonLabel: 'Protokoll kopieren',
  clearButtonLabel: 'Leeren',
  emptyLog: 'Noch keine Ereignisse. Scannen Sie einen Barcode, um die Protokollierung zu starten.',
  columns,
};
